import vulnerability from "public/cyber-security/vulnerability.jpg";

export const INTRO_CONSTANTS = {
  title: "Smarter Vulnerability & Patch Management - Powered by OneMind",
  text: "Cyber risks thrive in gaps — OneMind closes them with AI-driven detection, automated patching, and risk-based prioritization. Through integrations with Tenable and Red Hat we help you find, fix, and prevent security weaknesses before attackers exploit them. ",
  highlightedText: ["Tenable", "Red Hat"],
  image: vulnerability,
};
